module.exports = __webpack_public_path__ + "img/sky-logo.51a30afb.svg";